import { IEditVendorPayload, IGetVendorList, IVendorCreate, IVendorDetails, IVendorListSearch } from "../../../types/master/vendorInterface";
import { VendorActionTypes, VendorActions } from "../../actionTypes/master/vendorActionTypes";

export const createVendor = (payload: IVendorCreate): VendorActionTypes => ({
  type: VendorActions.CREATE_VENDOR,
  payload,
});

export const getVendorList = (payload: IVendorListSearch): VendorActionTypes => ({
  type: VendorActions.GET_VENDOR_LIST,
  payload,
});

export const setVendorList = (vendorList: Array<IGetVendorList>) : VendorActionTypes => ({
  type: VendorActions.SET_VENDOR_LIST,
  payload: vendorList
})

export const setVendorListPageCount = (payload:number): VendorActionTypes => ({
  type: VendorActions.SET_VENDOR_LIST_PAGE_COUNT,
  payload
})

export const getVendorDataById = (id: number | string): VendorActionTypes => ({
  type: VendorActions.GET_VENDOR_DATA_BY_ID,
  payload: id
})

export const setVendorDataById = (payload: IVendorDetails) => ({
  type: VendorActions.SET_VENDOR_DATA_BY_ID,
  payload
})

export const editVendor = (payload: IEditVendorPayload) => ({
  type: VendorActions.EDIT_VENDOR_DATA_BY_ID,
  payload,
});
